const prefix = 'booking';

export const LOAD_OCCUPIED_DATES = `${prefix}/LOAD_OCCUPIED_DATES`;

export const SET_TRIP_DATES = `${prefix}/SET_TRIP_DATES`;
export const SET_TRIP_DATES_AVAILABILITY = `${prefix}/SET_TRIP_DATES_AVAILABILITY`;
export const SET_LOCATION = `${prefix}/SET_LOCATION`;
export const SET_OCCUPIED_DATES = `${prefix}/SET_OCCUPIED_DATES`;
export const SET_EXTENSION = `${prefix}/SET_EXTENSION`;
